import { ISCDUser } from '@app-root-interfaces';

export class ProfileAddressHelper {
    private static readonly nationalGroup = ['DE', 'AT', 'CH'];

    public static getSalutation(profile: ISCDUser, language: string): string {
        return this.isNational(profile.country, language)
            ? this.getNationalSalutation(profile)
            : this.getInternationSalutation(profile);
    }

    public static getNationalSalutation(profile: ISCDUser) {
        const {
            graduateTitle,
            nickName,
            firstNameNat,
            firstName,
            administrativeGivenNameInt,
            administrativeGivenNameNat,
            surName,
            surNameNat,
            surnameAdd,
            surnameAmpr,
            preferredSN
        } = profile;

        const firstname =
            administrativeGivenNameNat || administrativeGivenNameInt || firstNameNat || firstName || nickName;
        const surname = surNameNat || surName || preferredSN;
        return `${graduateTitle || ''} ${firstname || ''} ${surnameAdd || ''} ${surnameAmpr || ''} ${surname || ''}`
            .trim()
            .replace(/\s\s+/g, ' ');
    }

    public static getInternationSalutation(profile: ISCDUser) {
        const {
            graduateTitle,
            nickName,
            firstNameNat,
            firstName,
            administrativeGivenNameInt,
            administrativeGivenNameNat,
            surName,
            surNameNat,
            preferredSN
        } = profile;
        const firstname =
            administrativeGivenNameNat || administrativeGivenNameInt || firstNameNat || firstName || nickName;
        const surname = surName || surNameNat || preferredSN;

        return `${graduateTitle || ''} ${firstname || ''} ${surname || ''}`.trim().replace(/\s\s+/g, ' ');
    }

    public static isNational(country: string, language: string): boolean {
        return (
            country.toUpperCase() === language.toUpperCase() ||
            (this.nationalGroup.includes(country.toUpperCase()) && this.nationalGroup.includes(language.toUpperCase()))
        );
    }
}
